import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Language } from '../constants/strings';

const LanguageSwitcher: React.FC = () => {
    const { language, setLanguage } = useLanguage();

    const handleLanguageChange = (newLanguage: Language) => {
        setLanguage(newLanguage);
        // Optionally save to localStorage for persistence
        localStorage.setItem('selectedLanguage', newLanguage);
    };

    return (
        <div className="language-switcher">
            <button
                className={`lang-btn ${language === 'et' ? 'active' : ''}`}
                onClick={() => handleLanguageChange('et')}
            >
                ET
            </button>
            <button
                className={`lang-btn ${language === 'en' ? 'active' : ''}`}
                onClick={() => handleLanguageChange('en')}
            >
                EN
            </button>
            <button
                className={`lang-btn ${language === 'ru' ? 'active' : ''}`}
                onClick={() => handleLanguageChange('ru')}
            >
                RU
            </button>
        </div>
    );
};

export default LanguageSwitcher; 